// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @13.12.2018 15:04:20
import { RbacOperation_abstract } from './../../abstract/SagaBase/RBAC/RbacOperation_abstract';
export class RbacOperation extends RbacOperation_abstract {}
